import styles from './Button.module.scss';

type ButtonProps = {
  buttonType?: 'button' | 'submit' | 'reset';
  text: string;
  disabled?: boolean;
  styleType?: 'primary' | 'secondary' | 'secondaryMini' | 'secondaryWide' | 'ghost' | 'text';
  addClass?: string[];
  handleClick?: () => void;
};

export const Button = ({
  buttonType = 'button',
  text,
  disabled,
  styleType = 'primary',
  addClass = [],
  handleClick,
}: ButtonProps) => {
  return (
    <button
      className={[
        styles.button,
        ...addClass,
        styleType && styles[`--${styleType}`], // Changed from `type` to `styleType`
      ].join(' ')}
      type={buttonType}
      onClick={handleClick}
      disabled={disabled}
    >
      <span className={styles.text}>{text}</span>
    </button>
  );
};
